export default __webpack_public_path__ + "static/media/Image (12).97780ca9.png";